import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsApplianceDetailsModelSerialApplianceExists } from './cms-appliance-details-model-serial-appliance-exists.interface';
import { CmsApplianceDetailsModelSerialBenefitsPanel } from './cms-appliance-details-model-serial-benefits-panel.interface';
import { CmsApplianceDetailsModelSerialConfirmation } from './cms-appliance-details-model-serial-confirmation.interface';
import { CmsApplianceDetailsModelSerialExpiredLink } from './cms-appliance-details-model-serial-expired-link.interface';
import { CmsApplianceDetailsModelSerialForm } from './cms-appliance-details-model-serial-form.interface';

export interface CmsApplianceDetailsModelSerialPage
  extends CmsRegistrationRoot,
    CmsApplianceDetailsModelSerialForm {
  applianceDetailsModelSerialBenefitsPanel: CmsApplianceDetailsModelSerialBenefitsPanel;
  applianceDetailsModelSerialConfirmation: CmsApplianceDetailsModelSerialConfirmation;
  applianceDetailsModelSerialApplianceExists: CmsApplianceDetailsModelSerialApplianceExists;
  applianceDetailsModelSerialExpiredLink: CmsApplianceDetailsModelSerialExpiredLink;
}
